export default "/048cb1f2b29308e18768c65cfd51e426596a830c/8e8641da5546a83267ff7cb844712535.svg";